export const PREFERRED_COUNTRIES_BY_LOCALE: { [key: string]: string[] } = {
  'en-US': ['us', 'ca', 'mx'],
  'en-CA': ['us', 'ca', 'mx'],
  'en-GB': ['gb', 'ie'],
  'en-IE': ['gb', 'ie'],
};
